export default "__VITE_ASSET__x_EaS53r__"